import { apiSlice } from "./apiSlice";
import { USER_NOTIFICATION_SETTINGS_URL } from "../../constants/urls";

export const userNotificationSettingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationSettings: builder.query({
      query: () => ({
        url: USER_NOTIFICATION_SETTINGS_URL,
        method: "GET",
      }),
    }),
    updateNotificationSettings: builder.mutation({
      query: (body) => ({
        url: USER_NOTIFICATION_SETTINGS_URL,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetNotificationSettingsQuery,
  useLazyGetNotificationSettingsQuery,
  useUpdateNotificationSettingsMutation,
} = userNotificationSettingsApiSlice;
